"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
require("./Pagination.css");
var Direction;
(function (Direction) {
    Direction[Direction["previous"] = 0] = "previous";
    Direction[Direction["next"] = 1] = "next";
})(Direction = exports.Direction || (exports.Direction = {}));
/**
 * @see Props
 */
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        /********************* LIFECYCLE METHODS END ********************************/
        _this.buildPageLinks = function () {
            var _a = _this.props, _b = _a.currentPageAriaLabel, currentPageAriaLabel = _b === void 0 ? '' : _b, _c = _a.pagesAriaLabel, pagesAriaLabel = _c === void 0 ? '' : _c, _d = _a.totalPages, totalPages = _d === void 0 ? 1 : _d;
            var currentPage = _this.state.currentPage;
            var numberOfPageLinksToShow = _this.getNumberOfPageLinksToShow();
            var pageNumberList = [];
            /**
             * The "blob" is the group of page numbers in the middle between two
             * ellipses when there are many total pages.
             *
             * If this.props.numberOfPagesVisible is an even number, we
             * might get weird behavior due to no "middle" of the blob.
             */
            var blobSize = totalPages > 1 && numberOfPageLinksToShow > 1 ? numberOfPageLinksToShow - 2 : 0;
            var hasBlob = blobSize > 0;
            var blobNumberOfPageLinksOnEachSide = Math.floor(blobSize / 2);
            var neverShowEllipses = totalPages <= numberOfPageLinksToShow;
            // 1) Collect the first page link
            pageNumberList.push(_this.createPageLinkElement(1, currentPage === 1, currentPageAriaLabel, pagesAriaLabel));
            // 2) Collect the first ellipsis.
            if (!neverShowEllipses && hasBlob && currentPage > blobSize) {
                pageNumberList.push(_this.createEllipsisElement('previous-ellipsis'));
            }
            // 3) Collect the "blob" of page links between the first and last
            if (hasBlob) {
                var startIndex = void 0;
                if (currentPage <= blobSize) {
                    // Close to the beginning, so start blob there (this should always happen on small groups of pages with no ellipses)
                    startIndex = 2;
                }
                else if (currentPage > totalPages - blobSize) {
                    // Close to the end, so start blob there
                    startIndex = totalPages - blobSize;
                }
                else {
                    /**
                     * In the middle, so create a blob with an equal number of page links
                     * flanking the selected page link on each side.
                     */
                    startIndex = currentPage - blobNumberOfPageLinksOnEachSide;
                }
                for (var i = startIndex; i < startIndex + blobSize; i++) {
                    pageNumberList.push(_this.createPageLinkElement(i, currentPage === i, currentPageAriaLabel, pagesAriaLabel));
                }
            }
            //4) Collect the second ellipsis.
            if (!neverShowEllipses && hasBlob && currentPage <= totalPages - blobSize) {
                pageNumberList.push(_this.createEllipsisElement('next-ellipsis'));
            }
            // 5) Collect the last page link.
            if (totalPages > 1 && numberOfPageLinksToShow > 1) {
                pageNumberList.push(_this.createPageLinkElement(totalPages, currentPage === totalPages, currentPageAriaLabel, pagesAriaLabel));
            }
            return pageNumberList;
        };
        _this.createEllipsisElement = function (reactKey) {
            var ellipsisAttributes = {
                'aria-hidden': true,
                className: 'page-number ellipsis',
                disabled: true,
                type: 'button'
            };
            return (React.createElement("li", { key: reactKey },
                React.createElement("button", __assign({}, ellipsisAttributes), "...")));
        };
        _this.createPageLinkElement = function (pageIndex, isCurrentPage, currentPageAriaLabel, pagesAriaLabel) {
            var classes = ['page-number', 'p-bg-hv-grey70'];
            var pageLinkAttributes = {
                type: 'button',
                className: ''
            };
            if (isCurrentPage) {
                classes.pop();
                classes.push('current-page p-bg-grey30 p-t-light');
                pageLinkAttributes['aria-label'] = _this.replaceString(currentPageAriaLabel, '{0}', pageIndex);
                pageLinkAttributes['aria-current'] = true;
            }
            else {
                pageLinkAttributes['data-pageindex'] = pageIndex;
                pageLinkAttributes['aria-label'] = _this.replaceString(pagesAriaLabel, '{0}', pageIndex);
            }
            pageLinkAttributes.className = classes.join(' ');
            return (React.createElement("li", { key: "page-link " + pageIndex },
                React.createElement("button", __assign({}, pageLinkAttributes), String(pageIndex))));
        };
        _this.getListWrapperStyle = function () {
            var itemWidth = _this.props.itemWidth || 40;
            /**
             * Always leave space for ellipses even when not present to prevent the
             * layout from "jumping"
             */
            var listWidth = itemWidth * (_this.getNumberOfPageLinksToShow() + 2);
            return {
                width: listWidth
            };
        };
        _this.getNavigationArrowAttributes = function (direction) {
            var _a;
            var previous = {
                ariaLabel: _this.props.previousButtonAriaLabel || '',
                changePage: _this.previousPage,
                defaultClasses: ['previous', 'p-flip'],
                isActive: _this.isNotFirstPage,
                tooltip: _this.props.previousButtonTooltip
            };
            var next = {
                ariaLabel: _this.props.nextButtonAriaLabel || '',
                changePage: _this.nextPage,
                defaultClasses: ['next'],
                isActive: _this.isNotLastPage,
                tooltip: _this.props.nextButtonTooltip
            };
            // Upgrade Typescript version to 3.0+ to type objects with computed keys
            var navigation = (_a = {},
                _a[Direction.next] = next,
                _a[Direction.previous] = previous,
                _a);
            var navigationArrow = navigation[direction];
            var defaultClasses = ['page-nav-caret', 'p-icon-right-cursor'].concat(navigationArrow.defaultClasses);
            var defaultAttributes = {
                type: 'button'
            };
            var additionalClasses = [];
            var additionalAttributes;
            if (navigationArrow.isActive()) {
                var label = _this.replaceString(navigationArrow.ariaLabel, '{0}', navigationArrow.changePage());
                var tooltip = _this.replaceString(navigationArrow.tooltip, '{0}', navigationArrow.changePage());
                additionalClasses = ['p-bg-hv-grey70'];
                additionalAttributes = {
                    'aria-label': label,
                    onClick: function (e) { return _this.navigateTo(navigationArrow.changePage()); },
                    title: tooltip
                };
            }
            else {
                additionalAttributes = {
                    'aria-label': navigationArrow.ariaLabel,
                    disabled: true,
                    role: 'presentation',
                    title: navigationArrow.tooltip
                };
            }
            return __assign({}, defaultAttributes, additionalAttributes, { className: defaultClasses.concat(additionalClasses).join(' ') });
        };
        _this.getNumberOfPageLinksToShow = function () {
            var _a = _this.props, _b = _a.totalPages, totalPages = _b === void 0 ? 1 : _b, _c = _a.numberOfPagesVisible, numberOfPagesVisible = _c === void 0 ? 3 : _c;
            return totalPages < numberOfPagesVisible ? totalPages : numberOfPagesVisible;
        };
        _this.getRootAttributes = function () {
            return {
                'aria-label': _this.props.ariaLabel,
                className: 'p-pagination',
                'data-tag': _this.props.tag,
                role: 'navigation'
            };
        };
        _this.handleNumericPageLinkClick = function (event) {
            if (!event.target || !event.target.getAttribute('data-pageindex')) {
                return;
            }
            var pageIndex = Number(event.target.getAttribute('data-pageindex'));
            _this.navigateTo(pageIndex);
        };
        _this.isNotFirstPage = function () {
            return _this.state.currentPage > 1;
        };
        _this.isNotLastPage = function () {
            return _this.state.currentPage < (_this.props.totalPages || 1);
        };
        _this.navigateTo = function (pageNumber) {
            if (_this.props.scrollToPageTop === true || _this.props.scrollToPageTop === undefined) {
                _this.scrollToTop();
            }
            _this.setState({ currentPage: pageNumber });
            if (typeof _this.props.navigateToPageByNumber === 'function') {
                _this.props.navigateToPageByNumber(pageNumber);
            }
        };
        _this.nextPage = function () {
            return _this.state.currentPage + 1;
        };
        _this.previousPage = function () {
            return _this.state.currentPage - 1;
        };
        _this.scrollStep = function () {
            if (window.pageYOffset === 0) {
                clearInterval(_this.state.scrollIntervalId);
            }
            // Value of 50 comes from scroll button
            var remainingOffset = window.pageYOffset - 50;
            // Make sure pageYOffset is never negative so loop doesn't potentially go forever
            if (remainingOffset >= 0) {
                window.scrollTo(0, remainingOffset);
            }
            else {
                window.scrollTo(0, 0);
            }
        };
        _this.scrollToTop = function () {
            var FRAME_RATE_IN_MILLISECONDS_FOR_60_FPS = 16.66;
            var scrollIntervalId = window.setInterval(_this.scrollStep, FRAME_RATE_IN_MILLISECONDS_FOR_60_FPS);
            _this.setState({ scrollIntervalId: scrollIntervalId });
        };
        var _a = _this.props.currentPageNavigatedTo, currentPageNavigatedTo = _a === void 0 ? 1 : _a;
        _this.state = {
            currentPage: currentPageNavigatedTo,
            scrollIntervalId: 0
        };
        return _this;
    }
    /********************* LIFECYCLE METHODS BEGIN ******************************/
    Pagination.prototype.componentWillReceiveProps = function (props) {
        var _a = props.currentPageNavigatedTo, currentPageNavigatedTo = _a === void 0 ? 1 : _a;
        if (this.props.currentPageNavigatedTo !== currentPageNavigatedTo) {
            this.setState({ currentPage: currentPageNavigatedTo });
        }
    };
    Pagination.prototype.componentWillUnmount = function () {
        clearInterval(this.state.scrollIntervalId);
    };
    Pagination.prototype.replaceString = function (str, variable, replacement) {
        if (str === '' || typeof str !== 'string') {
            return '';
        }
        if (str.indexOf(variable) > -1) {
            return str.replace(variable, String(replacement));
        }
        return str + ", " + replacement;
    };
    Pagination.prototype.render = function () {
        return (React.createElement("nav", __assign({}, this.getRootAttributes()),
            React.createElement("button", __assign({}, this.getNavigationArrowAttributes(Direction.previous))),
            React.createElement("ol", { className: "page-number-list", onClick: this.handleNumericPageLinkClick, style: this.getListWrapperStyle() }, this.buildPageLinks()),
            React.createElement("button", __assign({}, this.getNavigationArrowAttributes(Direction.next)))));
    };
    return Pagination;
}(React.Component));
exports.Pagination = Pagination;
exports.default = Pagination;
//# sourceMappingURL=Pagination.js.map


//////////////////
// WEBPACK FOOTER
// ../@csod/pagination/build/control/Pagination.js
// module id = 953
// module chunks = 0